export const CONTROL_TYPE_OPTIONS = [
  { value: 'number' as const, label: 'Numerical Entry Field' },
  { value: 'text' as const, label: 'Text Entry Field' },
  { value: 'select' as const, label: 'Dropdown List' },
];

export const getQuestionTypeLabel = (controlType: string): string => {
  const option = CONTROL_TYPE_OPTIONS.find((opt) => opt.value === controlType);
  return option?.label || '';
};

export const getQuestionTypeOptions = () => CONTROL_TYPE_OPTIONS;
